import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useSession } from '../../context/SessionContext';
import productServices from '../../services/ProductsServices';
import CategoryList from '../../components/categories/CategoryList';

function CategoriesPage() {
    const { productTypes, hasProductTypes, setProductTypes } = useSession();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await productServices.getProductTypes();
            setProductTypes(res.data);
        } catch (err) {
            console.error('Failed to fetch categories:', err);
            setError('Unable to load categories. Please try again later.');
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!hasProductTypes) {
            fetchCategories();
        } else {
            setLoading(false);
        }
    }, [fetchCategories, hasProductTypes]);

    const categories = hasProductTypes ? productTypes : [];

    if (loading) {
        return (
            <section className="py-10">
                <div className="container mx-auto px-4 text-center">
                    <p className="text-gray-600 dark:text-gray-400">Loading categories...</p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="py-10">
                <div className="container mx-auto px-4 text-center">
                    <p className="text-red-600">{error}</p>
                </div>
            </section>
        );
    }

    return (
        <>

            <header className="hero-bg text-white py-16">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-6xl font-black">Categories</h1>
                    <p className="mt-4 text-lg text-gray-300">Find the products you love from our popular categories.</p>
                    <div className="mt-6 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                </div>
            </header>
            <section className="py-10">
                <div className="container mx-auto px-4">

                    {categories.length === 0 ? (
                        <div className="text-center text-gray-500">No categories available.</div>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                            {categories.map((category) => (
                                <Link
                                    key={category.id}
                                    className="group relative block rounded-lg overflow-hidden shadow-lg"
                                    to={`/products?product_type=${category.id}`}
                                >
                                    <img
                                        alt={`${category.name} Category`}
                                        className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                                        src={category?.image}
                                    />
                                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                        <h3 className="text-white text-xl font-black uppercase tracking-wider">
                                            {category?.name}
                                            <span className="ml-3">({category?.product_count})</span>
                                        </h3>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                    <CategoryList isHome={0}/>
                </div>
            </section>
        </>
    );
}

export default CategoriesPage;